//
// Copyright (c) 2021 Astute Global, Inc.
//

import CategoriesModule from "modules/shared/categories/categoriesModule";
import MarionetteView from "../../marionetteView";
import { uid } from "ckeditor5";
import Messenger from "messaging/messenger";

export default class ResponseCategoriesListView extends MarionetteView {
  constructor(locale) {
    super(locale);
    this.set("categoryId", null);
    this.set("categoryName", null);
    this.set("responseId", null);
    this.namespace = "responseCategories-" + uid();
  }

  createModule() {
    const module = new CategoriesModule({
      region: this.region,
      namespace: this.namespace,
    });
    this.on("change:categoryId", (evt, name, newCategoryId) => {
      module.setSelected(newCategoryId);
    });
    return module;
  }

  focus() {
    if (this.module) {
      this.module.focus();
    }
  }

  setUpVents() {
    Messenger.vent.on(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onListItemSelected,
      this,
    );
  }

  showModule() {
    this.module.show({
      responseId: this.responseId,
    });
    this.module.setSelected(this.variableId);
  }

  tearDownVents() {
    Messenger.vent.off(
      Messenger.getFullName("list:item:selected", this.namespace),
      this._onListItemSelected,
      this,
    );
  }

  _onListItemSelected(model) {
    this.categoryId = model.get("categoryId");
    this.categoryName = model.get("categoryName");
  }
}
